import React from 'react';
import PropTypes from 'prop-types';
import {sanitizeHtml} from '../../common/util/sanitizeHtml';

export default class SafeHTML extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        noSanitize: PropTypes.bool,
        title: PropTypes.string,
        value: PropTypes.any,
    };

    render() {
        let html = this.props.value;
        if (!this.props.noSanitize) {
            html = sanitizeHtml(html);
        }
        return (
            <span className={this.props.className} dangerouslySetInnerHTML={{__html: html}} title={this.props.title}></span>
        );
    }
}
